module.exports = __webpack_public_path__ + "static/media/search-black.f62d4aa0.svg";